import { isNil } from 'lodash';

export const pxToRem = (value: number) => `${value / 16}rem`;

export const toImportant = (value: string | number | undefined) => (!isNil(value) ? `${value} !important` : '');
